import {useI18n} from 'i18n/I18nContext'
import React, {useState} from 'react'
import {TEMPLATES} from 'organization/Event/Certification/Builder/templates'
export const TemplateSelector = (props: {
  onSelect: (templateId: string) => void
}) => {
  const {t} = useI18n()
  const {onSelect} = props
  const [template, setTemplate] = useState<string>(TEMPLATES[0].templateId)
  const onSelectTemplate = (templateId: string) => {
    onSelect(templateId)
    setTemplate(templateId)
  }
  return (
    <>
      <label className="input__field-text">{t('orgCert.labelTemplates')}</label>
      <div className="contact__select mb-15">
        <select
          value={template}
          onChange={(e) => {
            onSelectTemplate(e.target.value)
          }}
        >
          {TEMPLATES.map((item) => (
            <option key={item.templateId} value={item.templateId}>
              {item.meta.nameKey ? t(item.meta.nameKey) : item.meta.name}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}
